/**
 * Toast Notification System
 * Provides user feedback for cart operations and other actions
 */

class ToastNotification extends HTMLElement {
  constructor() {
    super();
    this.timeout = null;
  }

  connectedCallback() {
    this.classList.add('toast-notification');
  }

  show(type, title, message, duration = 5000) {
    this.setAttribute('data-type', type);
    this.innerHTML = `
      <div class="toast-notification__content">
        <div class="toast-notification__icon">
          ${this.getIcon(type)}
        </div>
        <div class="toast-notification__message">
          <div class="toast-notification__title">${title}</div>
          <div class="toast-notification__description">${message}</div>
        </div>
        <button class="toast-notification__close" type="button" aria-label="Close notification">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    `;

    // Add to DOM
    if (!document.querySelector('toast-container')) {
      const container = document.createElement('toast-container');
      container.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
        pointer-events: none;
      `;
      document.body.appendChild(container);
    }

    const container = document.querySelector('toast-container');
    container.appendChild(this);

    // Show animation
    requestAnimationFrame(() => {
      this.classList.add('show');
    });

    // Auto-hide
    this.timeout = setTimeout(() => {
      this.hide();
    }, duration);

    // Close button
    const closeBtn = this.querySelector('.toast-notification__close');
    closeBtn.addEventListener('click', () => this.hide());
  }

  hide() {
    this.classList.remove('show');
    setTimeout(() => {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    }, 300);
  }

  getIcon(type) {
    switch (type) {
      case 'error':
        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
      case 'success':
        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6666 5L7.49998 14.1667L3.33331 10" stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
      case 'info':
        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
      default:
        return '';
    }
  }
}

// Define the custom element
if (!customElements.get('toast-notification')) {
  customElements.define('toast-notification', ToastNotification);
}

// Static methods for easy use
class ToastManager {
  static show(type, title, message, duration) {
    const toast = document.createElement('toast-notification');
    toast.show(type, title, message, duration);
    return toast;
  }

  static success(title, message, duration) {
    return this.show('success', title, message, duration);
  }

  static error(title, message, duration) {
    return this.show('error', title, message, duration);
  }

  static info(title, message, duration) {
    return this.show('info', title, message, duration);
  }
}

// Export for use in other scripts
window.ToastManager = ToastManager;
